  function checkUseragent(mode){
    if (window.navigator.userAgentData) {
      const uaData = navigator.userAgentData;
      console.log(uaData);

      (async () => {
      const highEntropyValues = await uaData.getHighEntropyValues([
        "model",
        "mobile",
      ]);
      // デバイスモデル。"Pixel 2 XL"など
      const model = highEntropyValues.model;
      // console.log('model =' + model);
      // モバイル端末かどうか
      const mobile = highEntropyValues.mobile;
      // console.log('mobile =' + mobile);
      if (mobile && model) {
        const myCollection = getCollectionByModel(model);
        if (myCollection !== false) {
          if(mode === 'top'){
            displayCustomerDeviceLink(myCollection.handle, myCollection.title.replace(/ ケース/, ''));
          } else if(mode === 'cart'){
            checkCartByGadget(myCollection.title.replace(/ ケース/, '')); 
          }
        }
      } else {
        // 判別不可能な場合は旧式（userAgent）で判定
        getByUserAgent(mode);
      }
      })();
    } else {
      // 旧式（userAgent）で判定
      getByUserAgent(mode);
    }

  }
  
  
  // userAgentから判定処理（userAgentData未対応の場合）
  function getByUserAgent(mode) {
    const ua = navigator.userAgent;
    if (ua.match(/iPod/i) && ua.match(/Mobile/i)){
      // iPod向けの処理
      // 画面サイズから機種判定
      const modelInfo = getiPodModel(screen.width, screen.height);

      if (modelInfo) {
        if(mode === 'top'){
          displayCustomerDeviceLink(modelInfo.url.split('::'), modelInfo.model.split('::'));
        } else if(mode === 'cart'){
          checkCartByGadget(modelInfo.model.split('::')); 
        }  
      }
    } else if (ua.match(/iPhone/i) && ua.match(/Mobile/i)){
      // iPhone向けの処理
      // 画面サイズから機種判定
      const modelInfo = getiPhoneModel(screen.width, screen.height);

      if (modelInfo) {
        if(mode === 'top'){
          displayCustomerDeviceLink(modelInfo.url.split('::'), modelInfo.model.split('::'));
        } else if(mode === 'cart'){
          checkCartByGadget(modelInfo.cartModel.split('::')); 
        }  
      }

    } else if (ua.match(/Android/i) && ua.match(/Mobile/i)){
      // Android向けの処理
      // userAgentから機種名を取得
      const model = getAndroidModelByUserAgent(ua);

      // 機種名が取得できたらコレクションと照合する
      if (model) {
        const myCollection = getCollectionByModel(model);

        if (myCollection !== false) {
          if(mode === 'top'){
            displayCustomerDeviceLink(myCollection.handle, myCollection.title.replace(/ ケース/, ''));
          } else if(mode === 'cart'){
            checkCartByGadget(myCollection.title.replace(/ ケース/, '')); 
          } 
        }
      }
    }

    return;
  }

  // 機種名からコレクション情報を返す
  function getCollectionByModel(model) {
    var res = false;

    // 特定機種の特殊処理(機種名とコレクションハンドルが一致しないケースの対応)
    switch (model) {
      case 'P710':
            model = 'rakuten-hand';
            break;
      case 'C330':
            model = 'rakuten-mini';
            break;
      case 'ASUS_X00QD':
            model = 'zenfone-5-ze620kl';
            break;
      default:
    }
    // 機種名を `小文字化 + スペースをハイフン` に
    let myModel = model.replace(/\s/g, '-').toLowerCase().trim();
    // コレクションオブジェクトを取得
    const myAllCollection = JSON.parse(
      document.getElementById("all-collections-obj").innerHTML
    );

    // 一致するもの返す
    for(let key = 0; key < myAllCollection.length; key++){
      if (myAllCollection[key].handle.endsWith(myModel)) {
        res = myAllCollection[key];
      break;
      }
    }

    // 一致するものがない場合はスペース（ハイフン）を削除して再検索
    if (!res && myModel.match(/-/)) {
      for(let key = 0; key < myAllCollection.length; key++){
        if (myAllCollection[key].handle.endsWith(myModel.replace(/-/, ''))) {
          res = myAllCollection[key];
          break;
        }
      }
    }

    return res;
  }

  // userAgentの文字列からAndroid機種名を抜き出して返す
  function getAndroidModelByUserAgent(ua) {
    let res = false;
    let myModelMatch = ua.match(/^.*?\s*\((.*?)\).*?$/);
    // ua から機種情報部分を抜き出す `Linux; Android 13; Pixel 7 Build/QKQ1.200706.002`
    if (myModelMatch) {
      // `;` で分割 Linux, Android 13, Pixel 7 Build/QKQ1.200706.002
      let myModels = myModelMatch[1].split(';');
      if ("2" in myModels) {
        // 3番目を機種名とする `Pixel 7 Build/QKQ1.200706.002`
        let myModel = myModels[2].trim();
        let regex = /(.*?)\sBuild.*?/;
        // 機種名に `Build~~` が含まれてるか
        if (regex.test(myModel)) {
          myModels = myModel.match(regex);
          if ("1" in myModels) {
            // 機種名に `Build~~` が含まれていたら省く `Pixel 7`
            myModel = myModels[1].trim();
          }
        }
        res = myModel;
      }
    }

    return res;
  }

  // iPhoneの画面サイズから機種を返す
  function getiPhoneModel(width, height) {
    const deviceMap = [
        {
            width: 320,
            height: 568,
            models: "iPhone 5s::iPhone 5",
            // 機種一覧(/pages/iphone)にページが無い機種。リンクには出さず、カートの機種違いチェックにだけ使う
            cartOnly: "iPhone SE::iPhone 5/5s::iPhone 5c",
        },
        {
            width: 375,
            height: 667,
            models: "iPhone SE (第3世代)::iPhone SE (第2世代)::iPhone 8::iPhone 7::iPhone 6s::iPhone 6",
        },
        {
            width: 375,
            height: 812,
            models: "iPhone 13 mini::iPhone 12 mini::iPhone 11 Pro::iPhone XS::iPhone X",
        },
        {
            width: 390,
            height: 844,
            models: "iPhone 17e::iPhone 16e::iPhone 14::iPhone 13 Pro::iPhone 13::iPhone 12 Pro::iPhone 12",
        },
        {
            width: 393,
            height: 852,
            models: "iPhone 16::iPhone 15::iPhone 15 Pro::iPhone 14 Pro",
        },
        {
            width: 414,
            height: 736,
            models: "iPhone 8 Plus::iPhone 7 Plus::iPhone 6s Plus::iPhone 6 Plus",
        },
        {
            width: 402,
            height: 874,
            models: "iPhone 18 Pro::iPhone 17::iPhone 17 Pro::iPhone 16 Pro",
        },
        {
            width: 414,
            height: 896,
            models: "iPhone 11::iPhone 11 Pro Max::iPhone XR::iPhone XS Max",
        },
        {
            width: 420,
            height: 912,
            models: "iPhone Air",
        },
        {
            width: 428,
            height: 926,
            models: "iPhone 14 Plus::iPhone 13 Pro Max::iPhone 12 Pro Max",
        },
        {
            width: 430,
            height: 932,
            models: "iPhone 16 Plus::iPhone 15 Plus::iPhone 15 Pro Max::iPhone 14 Pro Max",
        },
        {
            width: 440,
            height: 956,
            models: "iPhone 18 Pro Max::iPhone 17 Pro Max::iPhone 16 Pro Max",
        },
    ];

    const match = deviceMap.find(
        (d) =>
            (Number(width) === d.width && Number(height) === d.height) ||
            (Number(width) === d.height && Number(height) === d.width)
    );

    // 機種名から作るURL(iPhone 17 Pro → iphone17-pro)と実際のコレクションURLが違う機種
    const urlOverrides = {
        "iPhone 11": "iphone-11",
        "iPhone 18 Pro": "iphone-18-pro",
        "iPhone 18 Pro Max": "iphone-18-pro-max",
    };

    if (match) {
        const urls = match.models.split("::").map(model =>
          urlOverrides[model] || model.replace(/iPhone X$/, "iphonex")
                .replace(/iPhone (\d+)/, "iPhone$1")
                .replace(/ \(第3世代\)/, "-3")
                .replace(/ \(第2世代\)/, "-2")
                .toLowerCase().replace(/\s+/g, "-")
        ).join("::");
        // cartModel: カートの機種違いチェック用(リンクを出さない機種も含む)
        const cartModel = match.cartOnly ? match.models + "::" + match.cartOnly : match.models;
        return { url: urls, model: match.models, cartModel: cartModel };
    }

    return false;
  }

  // iPodの画面サイズから機種を返す
  function getiPodModel(width, height) {
    let res = false;
    let myUrls = false;
    let myModels = false;
    if ( (Number(width) === 320 && Number(height) === 568) || (Number(width) === 568 && Number(height) === 320) ) {
      myUrls = 'ipod-touch-7::ipod-touch-6';
      myModels = 'iPod touch 第7世代::iPod touch 第6世代';
    }

    if (myUrls && myModels) {
      res = { url: myUrls, model: myModels };
    }

    return res;
  }

// 「あなたの機種は」のリンクを表示
function displayCustomerDeviceLink(url, model) {
  let myLink = '';
  // パラメーターが配列かどうか
  if (Array.isArray(url)) {
    myLink += '<p>';
    for (var i = 0; i < url.length; i++) {
      myLink += '<a href="https://smaphocase.com/collections/' + url[i] + '" onclick="ga(\'send\', \'event\', \'スマホトップ機種判定リンク\', \'クリック\', \'' + model[i] + '\', 1);">' + model[i] + '</a><br>';
    }
    // 最後の `<br>` を取る
    myLink = myLink.replace(/<br>$/, '');
    myLink += '</p>';
  } else {
    myLink += '<p><a href="https://smaphocase.com/collections/' + url + '" onclick="ga(\'send\', \'event\', \'スマホトップ機種判定リンク\', \'クリック\', \'' + model + '\', 1);">' + model + '</a></p>';
  }

  let myLinkHtml = heredoc(`
<div class="bs-component">
  <div class="alert alert-success">
    <p>お客様の機種ページはこちらです。</p>
    {myLink}
    <p>他機種の場合は下記よりお選びください。</p>
  </div>
</div>
  `,{"myLink": myLink});

  // $('#getua').after(myLinkHtml);
  document.getElementById("getua").insertAdjacentHTML('afterend', myLinkHtml);

  return;
}

// ヒアドキュメントと置換
function heredoc(txt, dic){
  // 置換対象がなければ無視
  if(dic == null) return txt;

  Object.keys(dic).forEach(function (key) {
      txt = txt.replaceAll("{"+key+"}", dic[key]);
  });
  return txt;
}
// 端末モデル名を検知してコールバックで返す（汎用利用向け）
// callback(models: string[]) - iPhoneは同一画面サイズで複数候補あり
function detectDeviceModel(callback) {
  const ua = navigator.userAgent;
  if (!ua.match(/Mobile/i)) return;

  function dispatch(models) {
    if (models && models.length > 0) callback(models);
  }

  function detectByUA() {
    if (ua.match(/iPod/i)) {
      const modelInfo = getiPodModel(screen.width, screen.height);
      if (modelInfo) dispatch(modelInfo.model.split('::'));
    } else if (ua.match(/iPhone/i)) {
      const modelInfo = getiPhoneModel(screen.width, screen.height);
      if (modelInfo) dispatch(modelInfo.cartModel.split('::'));
    } else if (ua.match(/Android/i)) {
      const model = getAndroidModelByUserAgent(ua);
      if (model) dispatch([model]);
    }
  }

  if (navigator.userAgentData) {
    (async () => {
      const v = await navigator.userAgentData.getHighEntropyValues(['model', 'mobile']);
      if (v.mobile && v.model) {
        dispatch([v.model]);
      } else {
        detectByUA();
      }
    })();
  } else {
    detectByUA();
  }
}

// detectDeviceModel が定義されたことを通知（gadget_list_drawer.liquid 等で利用）
window.dispatchEvent(new CustomEvent('getua:ready'));

//アクセスしている機種とカート商品のマッチング
function checkCartByGadget(model){
  //let gadget_list @see main-cart-footer.liquid
  if(gadget_list.length < 1){
    return;
  }

  console.log(model);
  const uniqueArray = Array.from(new Set(gadget_list));
  console.log(uniqueArray);
  let match_gadget = false;
  let gadget_match_str,gadget_match,current_gadget;
  if(Array.isArray(model)){
    current_gadget = model[0].split(' ')[0];
    match_gadget = model.some(gadget=>{
      gadget_match_str = gadget.replaceAll(' ','\\s?') + '$';
      gadget_match = new RegExp(gadget_match_str);
      let check = false;
      uniqueArray.some(item=>{
        //console.log(item);
        //console.log(gadget_match);
        //console.log(item.match(gadget_match) );
        if(item.match(gadget_match) !== null){
          check = true;
          return true;
        }
      });

      if(check){
        return true;
      }
    });
  } else {
      current_gadget = model;
      gadget_match_str = model.replaceAll(' ','\\s?') + '$';
      gadget_match = new RegExp(gadget_match_str);
      match_gadget = uniqueArray.some(item=>{
        console.log(item);
        console.log(gadget_match);
        console.log(item.match(gadget_match) );
        if(item.match(gadget_match) !== null){
          check = true;
          return true;
        }
      });
  }

  if(!match_gadget){
    //現在ご利用中の機種〇〇とは違う機種がカートに入っていますので、内容が正しいかご確認ください
    document.getElementById("warning_gadget_check").innerText = "機種違いの可能性があります。\n現在お使いの機種: " + current_gadget + "\nこのまま購入すると、お使いの機種では使えない場合があります。カート内の商品に間違いがないかご確認ください。";
//    document.getElementById("warning_gadget_check").style.color = "red";
    document.getElementById("warning_gadget_check").style.display = "block";
  }

}